import {useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useAsync } from "../../../hooks/useAsync";
import BasicDialog from "../../base/BasicDialog";
import LoaderWrapper from "../../wrapper/LoaderWrapper";
import AutocompleteField from "../../field/AutocompleteField";
import { Button, Grid } from "@mui/material";
import useUserService from "../../../services/userService";



const SelectUserDialog = (props) => {
  const { t } = useTranslation();

  const [selectedUser, setSelectedUser] = useState()
  const [selectedUserObject, setSelectedUserObject] = useState()

  const { getUserSelectList } = useUserService();

  const userSelectList = useAsync(
    () => getUserSelectList(props.searchParams));

  const onChangeAutocompleteFieldWithObjectOptions = (
    e,
    value_object,
    value_key,
    state_value_name
  ) => {
    const newFormValue = Array.isArray(value_object)
      ? value_object.map((option) =>
        typeof option === "object" ? option[value_key] : option
      )
      : value_object[value_key];
      setSelectedUser(newFormValue)
      setSelectedUserObject(value_object)

  };
  const isLoading = userSelectList.loading

  const getDialogContent = () => {
    if (isLoading) return <LoaderWrapper showLoader={true} />;

    return (
      <>
        <Grid item xs={12}>
          <AutocompleteField
            name="user"
            label={t("dialog.select_user_dialog.user")}
            value={selectedUser}
            options={userSelectList ? userSelectList.value : []}
            isObjectOption={true}
            optionLabelKey={"full_name"}
            addNewValue={false}
            onChange={onChangeAutocompleteFieldWithObjectOptions}
            required
          />
        </Grid>
        <Button
          sx={{ marginTop: "20px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => props.onSubmit(props.returnObject ? selectedUserObject :selectedUser)}
          disabled={!selectedUser}
        >
          {t("confirm")}
        </Button>
      </>
    );
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      titleAlign="center"
      maxWidth="sm"
      title={t("dialog.select_user_dialog.select_user")}
    >
      {getDialogContent()}
    </BasicDialog>
  );
};

SelectUserDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  searchParams: PropTypes.string,
  returnObject : PropTypes.bool
};

SelectUserDialog.defaultProps = {
  searchParams: "",
  returnObject : false
};

export default SelectUserDialog;
